import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/**
 * Renders a fixed top banner when offline, and shows a toast when the
 * connection comes back. Mounted once at the root level.
 */
export function OnlineStatusBanner() {
  const isOnline = useOnlineStatus();
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOfflineRef.current = true;
      return;
    }
    if (wasOfflineRef.current) {
      wasOfflineRef.current = false;
      toast.success("接続が回復しました", { duration: 3000 });
    }
  }, [isOnline]);

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-destructive px-4 py-2 text-sm font-medium text-destructive-foreground shadow-md"
    >
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      <span>インターネット接続が切断されました</span>
    </div>
  );
}
